export const getLocation = async (processLocation = () => null, onLocationError = () => null) => {
  if ('geolocation' in navigator) {
    navigator.geolocation.getCurrentPosition(pos => {
      let lat = pos.coords.latitude;
      let lng = pos.coords.longitude;

      let locObject = {
        lat: lat,
        lng: lng,
        time: new Date().getTime(),
        date: new Date().toString(),
      };
      localStorage.setItem('xyz', JSON.stringify(locObject));
      processLocation?.(lat, lng);
    }, onLocationError);
  }
};

export const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1); // deg2rad below
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Distance in km
  return d;
};

export const deg2rad = deg => {
  return deg * (Math.PI / 180);
};

const LocBlankObj = {
  lat: 0,
  lng: 0,
  time: 0,
  date: 'error',
};

export const checkLastLocation = async (force = false) => {
  let xyz = JSON.parse(localStorage.getItem('xyz')) || LocBlankObj;
  if (xyz.time < new Date().getTime() - 2 * 36e5 || force) {
    await getLocation();
    xyz = JSON.parse(localStorage.getItem('xyz')) || LocBlankObj;
  }
  return xyz;
};

export const getLastLocation = () => {
  return JSON.parse(localStorage.getItem('xyz')) || LocBlankObj;
};
